import React, { useEffect } from 'react';
import { connect } from 'react-redux';

const GenericGuideTitle = (props) => {

    useEffect(() => {

    }, []);

    return (
        <div className='generic-guide-title' id={props.iContent.sectionName?.value}>
            {props.iContent.title?.value}
        </div>
    );
};

const mapStateToProps = (state) => {
    return {};
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(GenericGuideTitle);